<template>
<div>

  <!-- MALINA -->
  <div
          v-if="page.indexOf('malina') != -1"
          class="header"
  >
    <v-layout row wrap>
    <v-flex xs12 sm6 class="header-address-box text-xs-center text-md-left">
        г. Новокузнецк, Щорса, 5а к4
    </v-flex>
    <v-flex xs12 sm6 class="header-fone-box text-xs-center text-md-right">
        <div class="header-fone">

          <!--WHATSAPP-->
          <a href="https://wa.me/79512237737"
            target="_blank"
            onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
          >
            <v-btn
              fab
              dark
              small
              color="green"
            >
              <font-awesome-icon size="lg" :icon="['fab', 'whatsapp']"></font-awesome-icon>
            </v-btn>
          </a>

          <!--VIBER-->
          <a href="viber://chat?number=79512237737"
            target="_blank"
            onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
          >
            <v-btn
              fab
              dark
              small
              color="#59267c"
            >
              <font-awesome-icon size="lg" :icon="['fab', 'viber']"></font-awesome-icon>
            </v-btn>
          </a>

          <a href="tel:+79512237737"
            onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
          >+7 (951) 223-77-37</a>

        </div>
    </v-flex>
    </v-layout>
  </div>

  <!-- SADKO -->
  <div
          v-if="page.indexOf('sadko') != -1"
          class="header"
  >
    <v-layout row wrap>
      <v-flex xs12 sm6 class="header-address-box text-xs-center text-md-left">
        г. Новокузнецк, Орджоникидзе, 28а
      </v-flex>
      <v-flex xs12 sm6 class="header-fone-box text-xs-center text-md-right">
        <div class="header-fone">

          <!--WHATSAPP-->
          <a href="https://wa.me/79234640116"
             target="_blank"
             onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
          >
            <v-btn
                    fab
                    dark
                    small
                    color="green"
            >
              <font-awesome-icon size="lg" :icon="['fab', 'whatsapp']"></font-awesome-icon>
            </v-btn>
          </a>

          <!--VIBER-->
          <a href="viber://chat?number=79234640116"
             target="_blank"
             onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
          >
            <v-btn
                    fab
                    dark
                    small
                    color="#59267c"
            >
              <font-awesome-icon size="lg" :icon="['fab', 'viber']"></font-awesome-icon>
            </v-btn>
          </a>

          <a href="tel:+79234640116"
             onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
          >+7 (923) 464-01-16</a>

        </div>
      </v-flex>
    </v-layout>
  </div>

  <!-- ACROPOLIS -->
<!--  <div-->
<!--          v-if="page.indexOf('acropolis') != -1"-->
<!--          class="header"-->
<!--  >-->
<!--    <v-layout row wrap>-->
<!--      <v-flex xs12 sm6 class="header-address-box text-xs-center text-md-left">-->
<!--        г. Новокузнецк, Орджоникидзе, 13-->
<!--      </v-flex>-->
<!--      <v-flex xs12 sm6 class="header-fone-box text-xs-center text-md-right">-->
<!--        <div class="header-fone">-->

<!--          &lt;!&ndash;WHATSAPP&ndash;&gt;-->
<!--          <a href="https://wa.me/79617065757"-->
<!--             target="_blank"-->
<!--             onclick="yaCounter50723809.reachGoal('call_ok'); return true;"-->
<!--          >-->
<!--            <v-btn-->
<!--                    fab-->
<!--                    dark-->
<!--                    small-->
<!--                    color="green"-->
<!--            >-->
<!--              <font-awesome-icon size="lg" :icon="['fab', 'whatsapp']"></font-awesome-icon>-->
<!--            </v-btn>-->
<!--          </a>-->

<!--          &lt;!&ndash;VIBER&ndash;&gt;-->
<!--          <a href="viber://chat?number=79617065757"-->
<!--             target="_blank"-->
<!--             onclick="yaCounter50723809.reachGoal('call_ok'); return true;"-->
<!--          >-->
<!--            <v-btn-->
<!--                    fab-->
<!--                    dark-->
<!--                    small-->
<!--                    color="#59267c"-->
<!--            >-->
<!--              <font-awesome-icon size="lg" :icon="['fab', 'viber']"></font-awesome-icon>-->
<!--            </v-btn>-->
<!--          </a>-->

<!--          <a href="tel:+79617065757"-->
<!--             onclick="yaCounter50723809.reachGoal('call_ok'); return true;"-->
<!--          >+7 (961) 706-57-57</a>-->

<!--        </div>-->
<!--      </v-flex>-->
<!--    </v-layout>-->
<!--  </div>-->

</div>
</template>

<script>
export default {
  computed: {
    links () {
      return this.$store.state.links
    },
    page () {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.header {
  padding: 15px 20px;
  background-color: #FFFFFF;
  font-size: 16px;
}

.header-address-box {
  margin-top: 13px;
}

.header-fone {
  display: inline-block;
  text-align: center;
}

.header a,
.header a:hover
.header a:visited
.header a:active {
  font-size: 20px;
  color: green;
  text-decoration: none;
}

/* EXTRA SMALL */
@media (max-width: 600px) {
  .header-address-box {
    margin-top: 0px;
  }

  .header-fone-box {
    margin-top: 10px;
  }
}

/* SMALL */
@media (max-width: 960px) {
  .header a,
  .header a:hover
  .header a:visited
  .header a:active {
    font-size: 17px;
  }

  .header {
    font-size: 14px;
    padding: 15px 5px;
  }
}

/* MEDIUM */
@media (max-width: 1264px) {

}

/* LARGE */
@media (max-width: 1904px) {

}

/* X LARGE */
@media (min-width: 1904px) {

}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue